import { useState, useEffect } from 'react';

// Este hook se conecta al WebSocket y devuelve el precio actual de PROPT
export const useProptPrice = () => {
     const [price, setPrice] = useState(null);

     useEffect(() => {
          let isCancelled = false;
          let priceUpdated = false;

          const PROPT_ID = "b969a2df-e505-4376-b825-5cbc76469a20";
          const USDT_ID = "76d845ac-1e6a-4a1b-995b-762370e8c1cd";
          const wsUrl = `wss://limitlex.com/websocket/?c1=${PROPT_ID}&c2=${USDT_ID}`;
          const socket = new WebSocket(wsUrl);

          socket.addEventListener("message", (event) => {
               if (isCancelled) return;
               try {
                    const msg = JSON.parse(event.data);
                    if (msg.t === "best_bid_ask" && msg.currencyId1 === PROPT_ID && msg.ask && !priceUpdated) {
                         setPrice(parseFloat(msg.ask)); // Guardamos el precio como número
                         priceUpdated = true;
                         socket.close();
                    }
               } catch (err) {
                    console.error("Error processing socket message:", err);
               }
          });

          return () => {
               isCancelled = true;
               socket.close();
          };
     }, []);

     return price;
};